import { createSlice, PayloadAction } from "@reduxjs/toolkit"

export interface ProbingQuestion {
  problem_id?: string
  title?: string
  statement_markdown?: string
  constraints?: string | null
  examples?: { input?: string; output?: string }[]
  difficulty?: string
  topics?: string[]
}

export interface ProbingStudentSolution {
  language?: string | null
  content?: string
}

export interface ProbingPanel {
  panel_layout?: string
  question?: ProbingQuestion
  student_solution?: ProbingStudentSolution
}

export enum ProbingStages {
  Waiting,
  Setup,
  Live,
}

export interface ProbingState {
  sessionId: string | null
  testSlug: string | null
  probingType: string | null
  panelLayout: string | null
  panel: ProbingPanel | null
  currentStage: ProbingStages
}

const initialState: ProbingState = {
  sessionId: null,
  testSlug: null,
  probingType: null,
  panelLayout: null,
  panel: null,
  currentStage: ProbingStages.Waiting,
}

const probingSlice = createSlice({
  name: "probing",
  initialState,
  reducers: {
    setProbingSession: (state, action: PayloadAction<Partial<ProbingState>>) => ({
      ...state,
      ...action.payload,
    }),
    setProbingStage: (state, action: PayloadAction<ProbingStages>) => {
      state.currentStage = action.payload
    },
    resetProbing: () => initialState,
  },
})

export const { setProbingSession, setProbingStage, resetProbing } = probingSlice.actions
export default probingSlice.reducer
